export default __webpack_public_path__ + "static/media/logo-gins.2faf383b.jpg";